import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";
import Section13 from "./Section13";
import Section14 from "./Section14";

export default function Shopify() {
  return (
    <div className="Shopify pt-[160px] sm:pt-0">
      <Helmet>
        <title>Professional Shopify Services for Online Stores.</title>
        <meta
          name="description"
          content="Get expert Shopify store design and development services with Mean3. Build a high-converting, mobile-friendly Shopify store today!"
        />
      </Helmet>

      <Section1 />
      <Section12 />
      <Section2 />
      <Section4 />
      <Section3 />
      <Section5 />
      <Section13 />
      <Section6 />
      <Section14 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
      <Section11 />
    </div>
  );
}
